/**
 * Note: Before developing this content,
 * you must first define the theme token values the component.
 */
import { generateDynamicThemeToken } from '../../ThemeProvider';
import { getDynamicThemeToken } from './theme';
import { randomStr } from '../../Shared';
const componentName = 'Empty';
const classPrefix = `ui-Empty`;
/**
 * The classes here are the independent classes of the react-ui component.
 * It is mainly isolated from the classes of the mui component.
 * Avoid style conflicts when mui and react-ui are used simultaneously in project applications.
 *
 * On the way to develop react-ui components based on mui,
 * you must use this react-ui classes instead of mui classes.
 * You can control the built-in classes of the mui component through the classes prop of mui component.
 */
export const emptyClasses = {
    // It is recommended that the root classname of the react-ui component be added with a random string.
    // This is mainly to avoid classname naming conflicts in the application
    root: `${classPrefix}-root-${randomStr()}`,
    image: `${classPrefix}-image`,
    description: `${classPrefix}-description`,
    footer: `${classPrefix}-footer`,
};
/**
 * All style css codes of react-ui components are centrally managed in this method through classes.
 * Through this method, the light and dark themes of the components can be controlled.
 * You don't need to care about the implementation of theme switching.
 * You only need to define the specified style value based on the content of the token.
 */
export function getStyle(theme) {
    // getDynamicThemeToken It can dynamically control the semantic design token of the current component.
    // It is a dynamtic theme token to control two themes (light and dark) of this component.
    const dynamicToken = getDynamicThemeToken(theme);
    // generateDynamicThemeToken will return two contents, one is token data, and the other is tk method.
    // The token includes the light and dark theme style values defined by this component,
    // and it will automatically switch the token content of light or dark according to the outer ThemeProvider.
    // The role of tk is to process custom theme configuration,
    // and override the application custom token to the default light or dark token.
    const [token, tk] = generateDynamicThemeToken({
        componentName,
        theme,
        dynamicToken,
    });
    const style = {
        [`&.${emptyClasses.root}`]: {
            padding: tk(token.padding),
            textAlign: 'center',
            [`.${emptyClasses.image}`]: {
                display: 'flex',
                justifyContent: 'center',
                marginBottom: tk(token.margin),
            },
            [`.${emptyClasses.image} img`]: {
                height: '100%',
            },
            [`.${emptyClasses.description}`]: {
                fontFamily: tk(token.fontFamily),
                fontSize: tk(token.fontSize.title),
                color: tk(token.color.title),
                fontWeight: tk(token.fontWeight.title),
                lineHeight: '20px',
            },
            [`.${emptyClasses.footer}`]: {
                marginTop: '4px',
                fontSize: tk(token.fontSize.body),
                fontWeight: tk(token.fontWeight.body),
                color: tk(token.color.body),
                lineHeight: '20px',
                fontFamily: tk(token.fontFamily),
            },
        },
    };
    return style;
}
